import React, { Fragment } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { Icon } from '@mui/material'
import TouchRipple from '@mui/material/ButtonBase'
import MatxVerticalNavExpansionPanel from './MatxVerticalNavExpansionPanel'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'
import useSettings from 'app/hooks/useSettings'
import { twMerge } from 'tailwind-merge'

const useStyles = makeStyles(({ palette, ...theme }) => ({
    navItem: {
        transition: 'all 150ms ease-in',
        paddingLeft: '0.8rem',

        height: '48px !important',
        '&:hover': {
            backgroundColor: palette.action.hover,
        },
    },
    navItemActive: {
        backgroundColor: palette.action.selected,
        '& img': {
             filter: 'invert(48%) sepia(44%) saturate(1580%) hue-rotate(319deg) brightness(101%) contrast(86%)'
        },
        '& span': {
            color: '#ED636E !important' 
        }

    },
    activeColor: {
        color: '#ED636E !important' 
    },
    filterActiveColor: {
        filter: 'invert(48%) sepia(44%) saturate(1580%) hue-rotate(319deg) brightness(101%) contrast(86%)'
    },
    compactNavItem: {
        paddingLeft: 0,
        overflow: 'hidden',
        // justifyContent: 'center !important',
        '& $itemText': {
            display: 'none',
        },
        '& $itemIcon': {
            display: 'none',
        },
    },
    itemIcon: {},
    itemText: {
        // fontSize: '1.3rem',
        fontSize: '1rem',
        paddingLeft: '2rem',
        color: '#151A25',
        fontWeight: 500,
    },
    label: {
        color: palette.text.body,
    },
    bulletIcon: {
        background: '#C4C4C4'// palette.text.secondary,
    },
}))

const MatxVerticalNav = ({ items }) => {
    const { settings } = useSettings()
    const { mode } = settings.layout1Settings.leftSidebar
    const classes = useStyles()
    const location = useLocation();

    const renderLevels = (data) => {
        return !data ? null : data.map((item, index) => {
            if (item.type === 'label')
                return (
                    <p
                        key={index}
                        className={clsx({
                            'px-4 mb-2 mt-6 uppercase text-12 sidenavHoverShow': true,
                            [classes.label]: true,
                            hidden: mode === 'compact',
                        })}
                    >
                        {item.label}
                    </p>
                )
            if (item.children) {
                return (
                    <MatxVerticalNavExpansionPanel
                        mode={mode}
                        item={item}
                        key={index}
                    >
                        {renderLevels(item.children)}
                    </MatxVerticalNavExpansionPanel>
                )
            } else if (item.type === 'extLink') {
                return (
                    <a
                        key={index}
                        href={item.path}
                        className={clsx({
                            'flex justify-between h-44 border-radius-4 mb-2 compactNavItem whitespace-pre overflow-hidden': true,
                            [classes.navItem]: true,
                            [classes.compactNavItem]: mode === 'compact',
                        })}
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        <TouchRipple
                            key={item.name}
                            name="child"
                            className="w-full"
                        >
                            {(() => {
                                if (item.icon) {
                                    return (
                                        <Icon className="text-18 align-middle px-4">
                                            {item.icon}
                                        </Icon>
                                    )
                                }else if(item.urlIcon){
                                    return <img src={item.urlIcon} alt="icone" className="w-24" /> ;
                                } else {
                                    return (
                                        <span className="item-icon icon-text">
                                            {item.iconText}
                                        </span>
                                    )
                                }
                            })()}
                            <span
                                className={clsx(
                                    'align-middle sidenavHoverShow',
                                    classes.itemText
                                )}
                            >
                                {item.name}
                            </span>
                            <div className="mx-auto"></div>
                            {item.badge && (
                                <div
                                    className={`rounded bg-${item.badge.color} px-1 py-1px`}
                                >
                                    {item.badge.value}
                                </div>
                            )}
                        </TouchRipple>
                    </a>
                )
            } else {
                return (
                    <NavLink
                        key={index}
                        to={item.path}
                        activeClassName={classes.navItemActive}
                        className={clsx({
                            'flex justify-between tw-rounded-full tw-mt-4 compactNavItem whitespace-pre overflow-hidden': true,
                            [classes.navItem]: true,
                            [classes.compactNavItem]: mode === 'compact',
                        })}
                    >
                            <TouchRipple
                                key={item.name}
                                name="child"
                                className="tw-py-4 w-full"
                            >
                                {item?.icon ? (
                                    <Icon  className={clsx({
                                        "tw-ml-2  text-18 align-middle w-36 px-4": true,
                                        [classes.filterActiveColor]: location.pathname == item.path,
                                    })}>
                                        {item.icon}
                                    </Icon>
                                ) :
                                item?.urlIcon ? (
                                    <img className={clsx({
                                        "tw-ml-2  tw-w-6": true,
                                        [classes.filterActiveColor]: location.pathname == item.path,
                                    })} src={item.urlIcon} alt='icon'  />
                                ):(
                                    <Fragment>
                                        <div
                                            className={clsx({
                                                'nav-bullet p-2px rounded ml-6 mr-2': true,
                                                [classes.bulletIcon]: true,
                                                hidden: mode === 'compact',
                                            })}
                                        ></div>
                                        <div
                                            className={clsx({
                                                'nav-bullet-text ml-5 text-11': true,
                                                hidden: mode !== 'compact',
                                            })}
                                        >
                                            {item.iconText}
                                        </div>
                                    </Fragment>
                                )}
                                <span
                                    className={twMerge(
                                        clsx({
                                            'align-middle text-left sidenavHoverShow': true,
                                            [classes.itemText]: true,
                                            [classes.activeColor]: location.pathname == item.path,
                                        })
                                    )}
                                >
                                    {item.name}
                                </span>
                                <div className="mx-auto"></div>
                                {item.badge && (
                                    <div
                                        className={clsx(
                                            `rounded bg-${item.badge.color} px-1 py-1px`,
                                            'sidenavHoverShow',
                                            classes.itemIcon
                                        )}
                                    >
                                        {item.badge.value}
                                    </div>
                                )}
                            </TouchRipple>
                        
                    </NavLink>
                )
            }
        })
    }

    return <div className="navigation">{renderLevels(items)}</div>
}

export default React.memo(MatxVerticalNav)
